<template>
  <layout-main-inner :title="`商品详情(${info.isVirtualProductBundle === 1 ? '组合': '单一'})`">
    <template slot="action">
      <el-button
        type="primary"
        :loading="loading"
        @click="update">编辑</el-button>
    </template>
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">基本信息</template>
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="110px"
        class="margin-botton-0">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="商品名称：">{{ info.goodsName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品编码：">{{ info.productNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分组：">{{ info.groupName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="描述：">{{ info.goodsDesc }}</el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="支付方式：">{{ info.goodsPayType | payTypeFormat() }}</el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="售价：">
              <span
                v-if="info.isVirtualProductBundle === 1"
                slot="label">
                <span>售价：</span>
                <el-tooltip
                  effect="dark"
                  content="组合商品的价格根据组合内各个商品的价格自动计算">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <span v-if="info.goodsPayType===1">{{ info.price }}元</span>
              <span v-if="info.goodsPayType===2">{{ info.points }}积分</span>
              <!-- <span v-if="info.goodsPayType===9">{{info.price}}元 / {{info.points}}积分</span> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="库存：">{{ info.storageCount }}件</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已售数量：">{{ info.exchangeCount }}件</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态：">{{ info.status===1?'已上架':'未上架' }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="info.isVirtualProductBundle === 1"
          :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="组合商品："
              prop="virtualProductBundleBoms">
              <el-table
                style=""
                border
                :data="info.virtualProductBundleBoms">
                <el-table-column
                  label="商品名称"
                  prop="goodsName"
                  :resizable="false">
                </el-table-column>
                <el-table-column
                  label="商品编号"
                  width="90"
                  :resizable="false"
                  prop="productNumber">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  width="70"
                  label="商品分组"
                  prop="groupName">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  label="商品描述"
                  prop="goodsDesc"></el-table-column>
                <el-table-column
                  label="售价"
                  width="80"
                  :formatter="(row)=> '¥' + row.price"
                  prop="price">
                </el-table-column>
                <el-table-column
                  label="组合售价"
                  :resizable="false"
                  prop="inBomPrice">
                </el-table-column>
                <el-table-column
                  label="数量"
                  :resizable="false"
                  prop="inBomGoodsCount">
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="图片：">
              <!-- <img
                :src="info.goodsSmallImage"
                style="width: 120px;height: 120px;"> -->
              <image-list :list="info.goodsSmallImage" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图文详情：">
              <desc-images v-model="info.goodsDetailsImage"></desc-images>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import DescImages from '@/components/public/desc-images.vue'
import ImageList from '@/components/image-list.vue'
export default {
  name: 'GoodsDetail',
  components: {
    DescImages,
    ImageList
  },
  // filters: {
  //   payTypeFormat(value) {
  //     const type = {
  //       1: '现金',
  //       2: '积分',
  //       9: '现金/积分'
  //     }
  //     return type[value]
  //   }
  // },
  data() {
    return {
      loading: false,
      info: {
        // goodsName: '',
        // goodsDesc: '',
        // points: '',
        // storageCount: '',
        // status: null,
        // goodsDetailsImage: [],
        // goodsSmallImage: null
      }
    }
  },
  mounted() {
    this.getgoods()
  },
  methods: {
    update() {
      this.$router.push(`/wxapp-sku-edit?exchangeGoodsId=${this.info.exchangeGoodsId}&vendorId=${this.info.vendorId}`)
    },
    getgoods() {
      this.loading = true
      this.$store.dispatch('goods/getgoods', {
        payload: this.$route.query,
        success: res => {
          this.loading = false
          this.info = {
            ...res.data,
            goodsSmallImage: res.data.goodsSmallImage ? res.data.goodsSmallImage.split(',') : [],
            goodsDetailsImage: res.data.goodsDetailsImage ? res.data.goodsDetailsImage.split(',').map(item => ({
              url: item,
              name: item,
              mediaType: /(\.mp4|\.webm|\.avi)$/g.test(item) ? 2 : 1
            })) : []
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
